import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Dropdown, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type GiftVoucherModuleSpecsFragment } from '../../../../api/fragments/GiftVoucherModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

type GiftVoucherModuleActionsProps = {
    module: GiftVoucherModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const GiftVoucherModuleAction = ({ module, permissions }: GiftVoucherModuleActionsProps) => {
    const { t } = useTranslation(['giftVoucherModuleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('giftVoucherModuleDetails:actions.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown menu={{ items }}>
            <Button type="primary">
                <Space>
                    <span>{t('giftVoucherModuleDetails:actions.label')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default GiftVoucherModuleAction;
